import { Component, ElementRef, Inject, ViewEncapsulation } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ActionEventsEnum } from "@toro/common/shared/enum/tracking/action-events.enum";
import { DialogPanelComponentContent } from "@toro/common/shared/models/dialogs/DialogPanelComponentContent";
import { TrackingsService } from "../../../../../services/tracking.service";
import { FittingResponse, ParagraphResponse } from "../../../../models/santander-suitability/santander-suitability.model";

@Component({
  selector: 'stock-non-compliance-panel',
  templateUrl: './non-compliance-panel.component.html',
  styleUrls: ['./non-compliance-panel.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class NonCompliancePanelComponent extends DialogPanelComponentContent {
  public fitting: FittingResponse;
  public paragraph: ParagraphResponse | null = null;
  public paragraphFactors: string[] = [];
  public paragraphFactorsText = "";

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    protected element: ElementRef,
    private dialogReference: MatDialogRef<NonCompliancePanelComponent>,
    private trackingService: TrackingsService,
  ) {
    super(element, true);
    console.log('NonCompliancePanelComponent constructor called');
    console.log('Data received:', this.data);
    this.fitting = this.data && this.data.fitting;
    this.setParagraphData();
    console.log('Fitting assigned:', this.fitting);
  }

  ngOnInit(): void {
    super.ngOnInit();
    console.log('NonCompliancePanelComponent ngOnInit called');
    this.trackingService.sendMetricsToMixpanel(ActionEventsEnum.MODAL_OPENED, {
      'Product Area Origin': 'Bolsa',
      'Scenario': 'Termo de desenquadramento',
      'Step': 'Não se aplica',
      'Status': 'Não se aplica',
      'Text': 'Não se aplica',
      'Value': 'Não se aplica',
      'Time Responsável': 'Roebling',
    });
  }

  public dispose(event: Event) {
    super.close(this.dialogReference, null);
    event.preventDefault();
  }

  private setParagraphData(): void {
    this.paragraph = null;
    this.paragraphFactors = [];
    this.paragraphFactorsText = "";

    if (!this.fitting || !this.fitting.investmentFittingValidation) {
      return;
    }

    const validation = this.fitting.investmentFittingValidation;
    if (!validation.investmentFittingText || validation.investmentFittingText.length === 0) {
      return;
    }

    const firstParagraph = validation.investmentFittingText[0];
    if (!firstParagraph || !firstParagraph.paragraph) {
      return;
    }

    this.paragraph = firstParagraph.paragraph;
    if (this.paragraph.FatorDeInadequacao) {
      this.paragraphFactors = this.paragraph.FatorDeInadequacao;
      this.paragraphFactorsText = this.paragraphFactors.join(" ");
    }
  }
}
